/**
 * YouTube "lite": miniatura + przycisk, iframe ładuje się dopiero po kliknięciu.
 * Strona nie pobiera ~1 MB skryptów YouTube i nie ustawia ciasteczek przed kliknięciem.
 */
export const initYoutube = () => {
	document.addEventListener('click', (e) => {
		const link = e.target.closest('.js-yt-play');
		if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;

		e.preventDefault();

		const iframe = document.createElement('iframe');
		iframe.src = link.dataset.embed;
		iframe.title = link.dataset.title || 'Film YouTube';
		iframe.allow =
			'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
		iframe.allowFullscreen = true;
		iframe.referrerPolicy = 'strict-origin-when-cross-origin';
		iframe.className = 'absolute inset-0 size-full border-0';

		link.replaceWith(iframe);
		iframe.focus();
	});
};
